import React from 'react';


export const ContainerForm = ({children}) => {
    return (
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6  rounded-lg bg-blueGray-100 border-0">
            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                {children}
            </div>
        </div>
    );
};


